import Cookie from "js-cookie";
import styles from "./CookieConsentAcceptButton.module.css";

export default function CookieConsentAcceptButton(): JSX.Element {
  const generateBrowserId = () => {
    const randomId = crypto.randomUUID();
    const userAgent = navigator.userAgent;
    const language = navigator.language;
    const languages = navigator.languages;
    const cookiesEnables = navigator.cookieEnabled;
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const online = navigator.onLine;
    const viewPortWidth = window.innerWidth;
    const viewPortHeight = window.innerHeight;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return {
      randomId,
      userAgent,
      language,
      languages,
      cookiesEnables,
      screenWidth,
      screenHeight,
      online,
      viewPortWidth,
      viewPortHeight,
      timezone,
    };
  };

  const acceptCookie = () => {
    const cookieExpirationDate = new Date();
    cookieExpirationDate.setTime(
      cookieExpirationDate.getTime() + 7 * 24 * 60 * 60 * 1000
    ); // 7 days
    Cookie.set("cookiePolicy", JSON.stringify(generateBrowserId()), {
      path: "/",
      expires: cookieExpirationDate,
      sameSite: "Strict",
    });
  };

  return (
    <div
      data-icon-only="No"
      data-icon="No"
      data-size="Medium"
      data-state="Default"
      data-type="Primary"
      className={styles.button}
      role="button"
      tabIndex={0}
      onKeyDown={() => {
        acceptCookie();
        // localStorage.setItem("acceptedCookies", "true");
      }}
      onClick={() => {
        acceptCookie();
        // localStorage.setItem("acceptedCookies", "true");
      }}
    >
      <div className={styles.text}>Accept</div>
    </div>
  );
}
